module.exports = __webpack_public_path__ + "static/media/userWoman.2a423658.png";